import { render, staticRenderFns } from "./TaskNote.vue?vue&type=template&id=6e93c931&scoped=true&"
import script from "./TaskNote.vue?vue&type=script&lang=js&"
export * from "./TaskNote.vue?vue&type=script&lang=js&"
import style0 from "./TaskNote.vue?vue&type=style&index=0&id=6e93c931&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e93c931",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VIcon,VTooltip})
